import { render, staticRenderFns } from "./TradePwdPanel.vue?vue&type=template&id=0db61cea&scoped=true"
import script from "./TradePwdPanel.vue?vue&type=script&lang=js"
export * from "./TradePwdPanel.vue?vue&type=script&lang=js"
import style0 from "./TradePwdPanel.vue?vue&type=style&index=0&id=0db61cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db61cea",
  null
  
)

export default component.exports